import { get, writable } from 'svelte/store';

import type { RouteDetail } from 'svelte-spa-router';

const initialUrlParams: RouteDetail = undefined;

function create_after_login_params() {
	const { subscribe, set, update } = writable<RouteDetail>(initialUrlParams);

	return {
		subscribe,
		set,
		getURL: () => {
			let params = get(afterLoginParams);
			let url = params?.location;
			if (params?.querystring) {
				url = url + '?' + params.querystring;
			}
			return url;
		},
		update,
		reset: () => set(initialUrlParams),
	};
}

export const afterLoginParams = create_after_login_params();
